import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ImmediatePaymentService {
    private uncheckMedicalPrescriptionSubject = new BehaviorSubject<boolean>(false);
    uncheckMedicalPrescription$ = this.uncheckMedicalPrescriptionSubject.asObservable();

    setUncheckMedicalPrescription(value: boolean) {
        this.uncheckMedicalPrescriptionSubject.next(value);
    }
}